
import * as analysis from "../../contexts/AnalysisContext"
import { AnalysisView } from "../../components/analysis/AnalysisView"



export const Analysis = () => {

    
    return (

        <analysis.Provider>
            <AnalysisView/>
        </analysis.Provider>
    )
}


